import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import CONFIG from 'src/app/app.config';
import { User } from 'src/app/d3/models/user';
import { AuthenticateService } from 'src/app/services/authenticate/authenticate.service';
import { UserdataService } from 'src/app/services/user/userdata.service';
import { getAuth, ActionCodeSettings, sendSignInLinkToEmail, isSignInWithEmailLink } from 'firebase/auth';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { signInWithEmailLink } from '@angular/fire/auth';
import { AnalyticsService } from 'src/app/services/tracking/analytics.service';
import { BehaviorSubject, combineLatest } from 'rxjs';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  host: {
    'class':  'container cc-component-container cc-wrapper-container', 
    'id': 'auth-component-backdrop'
  },
})
export class AuthComponent implements OnInit {
  private readonly autoLogout = CONFIG.APPLICATION.URL.PARAMS.AUTO_LOGOUT;
  readonly urls = CONFIG.APPLICATION.URL; 
  isLoggedIn: Boolean; 
  checkEmail?: Boolean;
  appName: String = CONFIG.APPLICATION.META_DATA.TITLE;
  alias = CONFIG.APPLICATION.ANALYTICS.SCREENS.AUTHENTICATION;
  isLoggedIn$ = new BehaviorSubject<Boolean>(false); 
  userDetails$ = new BehaviorSubject<User | null>(this.userDataService.userDetails$.getValue());
  email?: string;
  signInForm: FormGroup;
  enableEmailAuth: Boolean = environment.enableEmailAuth;
  urlPaths = CONFIG.APPLICATION.URL;
  
  constructor(private authenticateService : AuthenticateService,
    private userDataService: UserdataService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private analyticsServie: AnalyticsService) { 
    this.isLoggedIn = this.authenticateService.isAuth();

     this.userDataService.userDetails$.subscribe((user) => {
      this.userDetails$.next(user);
      this.isLoggedIn$.next(!! user);
    });

    this.signInForm = this.formBuilder.group({
      email: []
    });

    if(! this.isLoggedIn$.getValue()) {
      if(this.userSignInWithEmailLink()) { //If user click the confirmation email.
        this.proceedWithLoginEmailUser();
        return;
      } 
      this.authenticateService.execAuth();
    }
  }

  ngOnInit(): void {
    combineLatest([this.route.queryParams, this.isLoggedIn$])
      .subscribe( (params: any) => {
      //Used to autologout users when done via apps or various redirects.
      let autoLogout = !! params[0][this.autoLogout];
      const redirectTo = params[0][this.urls.PARAMS.REDIRECT_TO] || false;
      if(autoLogout) {
        this.logout();
      } else if(redirectTo && params[1]) {
        this.goTo(decodeURIComponent(redirectTo));
      }
    });
  }

  logout() {
    this.userDataService.logOutSessions().then(() => {
      this.isLoggedIn$.next(false);
      this.analyticsServie.logEvent(`${this.alias}-logout`)
      window.location.replace(`${this.urls.AUTH}`);
    });
  }

  goTo(path : string) {
    this.analyticsServie.logEvent(`${this.alias}-${path}`)
    this.router.navigate([path]);     
  }


  sendRegistrationLink() {
    var email = this.signInForm.get("email")?.value;
    var authSettings: ActionCodeSettings = {
      url: environment.domain,
      handleCodeInApp: true
    };
    
    sendSignInLinkToEmail(getAuth(), email, authSettings).then( (resp) => {
      window.localStorage.setItem('emailForSignIn', email);
      this.checkEmail = true;
    }).catch((error) => {
      console.error("Send email error: ", error);
    }) 
  }

  userSignInWithEmailLink(): Boolean {
    return (isSignInWithEmailLink(getAuth(), window.location.href))
  }

  openAlert(content: any) {
    this.modalService.open(content);
  }

  proceedWithLoginEmailUser() {
    var email = window.localStorage.getItem("emailForSignIn");
    if(! email) {
      email = window.prompt("Please enter email for confirmation") || '';
    }
    var that = this;
    signInWithEmailLink(getAuth(), email, window.location.href).then((result: any) => {
      console.log("SignIn details: ", result);
      window.localStorage.removeItem("emailForSignIn");
      that.authenticateService.setAuthDetails(result);
      window.location.reload();
    }).catch((error) => {
      console.error("Failed to complete user login: ", error);
      window.localStorage.removeItem("emailForSignIn");
    })
  }
}

